export var ProductTypeEnum;
(function (ProductTypeEnum) {
    ProductTypeEnum["Regale"] = "regale";
    ProductTypeEnum["Wardrobe"] = "wardrobe";
    ProductTypeEnum["Sideboard"] = "sideboard";
})(ProductTypeEnum || (ProductTypeEnum = {}));
export var DoorPositionEnum;
(function (DoorPositionEnum) {
    DoorPositionEnum["Outer"] = "outer";
    DoorPositionEnum["Inner"] = "inner";
})(DoorPositionEnum || (DoorPositionEnum = {}));
export var DoorType;
(function (DoorType) {
    DoorType["Left"] = "left";
    DoorType["Right"] = "right";
    DoorType["Down"] = "down";
    DoorType["Drawer"] = "drawer";
    DoorType["Both"] = "door_both";
    DoorType["Up"] = "up";
    DoorType["Sliding"] = "sliding";
})(DoorType || (DoorType = {}));
export var InsideOptionType;
(function (InsideOptionType) {
    InsideOptionType["Pantograph"] = "pantograph";
    InsideOptionType["Rail"] = "rail";
    InsideOptionType["Split"] = "split";
    InsideOptionType["Drawer"] = "drawer";
    InsideOptionType["LedLight"] = "led_light";
    InsideOptionType["ClothesHolder"] = "clothes_holder";
    InsideOptionType["TrousersHolder"] = "trousers_holder";
    InsideOptionType["BeltHolder"] = "belt_holder";
})(InsideOptionType || (InsideOptionType = {}));
export var Side;
(function (Side) {
    Side["Left"] = "left";
    Side["Right"] = "right";
})(Side || (Side = {}));
export var SlidingDoorsType;
(function (SlidingDoorsType) {
    SlidingDoorsType["DOUBLE_LEFT"] = "double-left";
    SlidingDoorsType["DOUBLE_RIGHT"] = "double-right";
    SlidingDoorsType["TRIPLE"] = "triple-middle";
})(SlidingDoorsType || (SlidingDoorsType = {}));
//# sourceMappingURL=types.js.map